import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const ClassRoomService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.CLASS_ROOM, null, wait).then((data) => {
            callback(data);
        });
    },
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.CLASS_ROOM + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },
};